// extracted by mini-css-extract-plugin
export default {"addAPlanFromNoAccess":"iiLkpUpcc4i4_LG8DmfC","addAPlanFromnoAccessPMfa":"LIEME6on4RHB0ESA6vyuq","labelWithTooltip":"_25bIYwEl53ZNYWfLeFTVOQ"};